import * as CL from '@design-system/component-library';
import { useFormContext } from 'react-hook-form';
import { ElectronicAddress } from '../../../../common/react-hook-form/fields/ElectronicAddress';
import { ElectronicOperator } from '../../../../common/react-hook-form/fields/ElectronicOperator';
import { type EOperatorItem } from '../../../../common/utils/billingAccountUtils.js';
import { DeliveryMethodAndLanguageSelection } from '../../components/DeliveryMethodAndLanguageSelection.js';
import { GridColumn } from '../../components/GridColumn.js';
import type { CLDropdownItem } from '../../../../common/types/componentLibrary';
import type { BillChannel } from '../../../../generated/api/billChannel.js';

interface BillingAccountElectronicDeliveryMethodProps {
  deliveryMethodOptions: CLDropdownItem[];
  billChannels: BillChannel[];
  disabled?: boolean;
}

export const BillingAccountElectronicDeliveryMethodEdit = ({
  billChannels,
  deliveryMethodOptions,
  disabled = false,
}: BillingAccountElectronicDeliveryMethodProps) => {
  const { setValue, setError } = useFormContext();

  const handleOperatorChange = (selectedOperator?: EOperatorItem) => {
    if (selectedOperator?.active && selectedOperator?.electronicAddress) {
      setValue('billingAccount.billElectronicAddress', selectedOperator.electronicAddress);
    } else {
      setValue('billingAccount.billElectronicAddress', '');
    }
    setError('billingAccount.billElectronicAddress', { message: undefined });
  };

  return (
    <>
      <DeliveryMethodAndLanguageSelection deliveryMethodOptions={deliveryMethodOptions} disabled={disabled} />
      <CL.GridRow>
        <GridColumn className="of-billing-account-details form-column edit-field-large">
          <div>
            <ElectronicOperator
              name="billingAccount.billElectronicOperator"
              billChannels={billChannels}
              onOperatorChange={handleOperatorChange}
              disabled={disabled}
            />
          </div>
        </GridColumn>
        <GridColumn className="of-billing-account-details form-column edit-field">
          <ElectronicAddress name="billingAccount.billElectronicAddress" disabled={disabled} />
        </GridColumn>
      </CL.GridRow>
    </>
  );
};
